var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V18H0z",
    transform: "translate(-1209.000000, -345.000000) translate(1040.000000, 0.000000) translate(160.000000, 336.000000) translate(9.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M3.59 9.586c.326 0 .59.262.59.586 0 2.843 2.33 5.156 5.195 5.156.871 0 1.733-.218 2.492-.63.286-.156.645-.052.801.232.157.283.052.64-.234.795-.932.507-1.99.775-3.059.775-1.703 0-3.304-.658-4.508-1.853C3.663 13.45 3 11.862 3 10.172c0-.324.264-.586.59-.586zm4.126-7.912c.23-.23.603-.232.835-.004.212.208.231.537.056.768l-.052.06-1.342 1.346h2.162c1.703 0 3.304.658 4.508 1.853 1.204 1.195 1.867 2.785 1.867 4.475 0 1.094-.286 2.172-.826 3.118-.109.19-.309.297-.514.297-.099 0-.2-.025-.291-.077-.284-.16-.383-.517-.222-.798.44-.77.672-1.649.672-2.54 0-2.79-2.244-5.07-5.035-5.154l-.159-.002H7.199l1.326 1.348c.228.232.223.603-.01.829-.115.111-.264.166-.412.166-.128 0-.256-.04-.362-.122l-.06-.054-1.49-1.515c-.646-.656-.669-1.702-.073-2.386l.08-.087 1.518-1.521z",
    transform: "translate(-1209.000000, -345.000000) translate(1040.000000, 0.000000) translate(160.000000, 336.000000) translate(9.000000, 9.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon-return.c6683ffbf5de74b27d9741de43e35239.svg";
export { ForwardRef as ReactComponent };